

.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.dropdown-with-checkbox {
  display: flex;
  align-items: center;

  gz-dropdown {
    --form-field-input-width: 160px;
  }

  gz-form-field + gz-form-field {
    margin-left: 32px;
  }
}

gz-button {
  margin-right: 15px;
}

#antimalware-dynamic-attack-types-field {
  width: 100%;
}
